import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";
import { Employee } from "@/models/Employee";

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `Employee/getField`,
  mutationType: `Employee/updateField`
});

const state = {
  employees: []
};

const actions = {
  DeleteEmployee({ commit, dispatch }, employee) {
    return new Promise((resolve, reject) => {
      HTTP.delete("DealerPortal/DeleteEmployee", { data: employee })
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Employees removed",
              httpStatus: 200
            }),
            { root: true }
          );
          resolve(true);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in removing employee : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
        });
    });
  },
  GetAllEmployeesForDealer({ commit, dispatch }) {
    return new Promise((resolve, dispatch) => {
      let Employees = HTTP.get("DealerPortal/ListEmployees");
      Employees.then(result => {
        commit("setEmployees", result.data);
        resolve(result.data);
      }).catch(error => {
        dispatch(
          "message/setMessage",
          new httpError({
            message: "Error in getting Employees for dealer : " + error.message,
            httpStatus: 500
          }),
          { root: true }
        );
      });
    });
  },
  addEmployee({ state, commit, dispatch }, employee) {
    return new Promise((resolve, reject) => {
      if (!employee) {
        dispatch(
          "message/setMessage",
          new httpError({
            message: "Invalid employee details",
            httpStatus: 500
          }),
          { root: true }
        );
        reject("no employee given");
        return;
      }

      HTTP.post("DealerPortal/CreateEmployee", employee)
        .then(data => {
          if (data.status == 200) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Employee Saved",
                httpStatus: 200
              }),
              { root: true }
            );
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.response.data,
              httpStatus: 500
            }),
            { root: true }
          );
          reject("no employee given");
        });
    });
  },
  getEmployee({ state }, employeeID) {
    return new Promise((resolve, reject) => {
      let employee = state.employees.filter(x => x.id == employeeID);
      if (employee) resolve(employee[0]);
      else reject();
    });
  }
};

const mutations = {
  setEmployees(state, employees) {
    state.employees = employees;
  },
  clearRows(state) {
    if (typeof state.rows !== "object") state.rows = [];
    state.rows.length = 0;
    state.rows.push(new Employee());
  },
  removeRow(state) {
    state.rows.pop();
  },
  setRows(state, upload) {
    state.rows.length = 0;
    state.rows = upload;
  },
  setSession(state, session) {
    state.session = session;
  },
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
